"use strict";
var import_vitest = require("vitest");
var import_workerHandler = require("./workerHandler");
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
var pageRoute = {
  file: "./some-page.tsx",
  page: "/some-page",
  namedRegex: "^/some-page(?:/)?$",
  urlPath: "/some-page",
  urlCleanPath: "/some-page",
  routeKeys: {},
  type: "ssr",
  middlewares: []
};
var apiRoute = {
  file: "./api/status+api.ts",
  page: "/api/status",
  namedRegex: "^/api/status(?:/)?$",
  urlPath: "/api/status",
  urlCleanPath: "/api/status",
  routeKeys: {},
  type: "api",
  middlewares: []
};
var buildInfo = {
  constants: {
    CACHE_KEY: "test"
  },
  routeToBuildInfo: {
    [pageRoute.file]: {
      type: "ssr",
      path: pageRoute.page,
      routeFile: pageRoute.file,
      middlewares: [],
      preloadPath: "",
      cssPreloadPath: "",
      loaderPath: "",
      cleanPath: pageRoute.page,
      htmlPath: "",
      clientJsPath: "",
      serverJsPath: "",
      params: {},
      preloads: [],
      css: [],
      layoutCSS: []
    }
  },
  pathToRoute: {},
  routeMap: {},
  manifest: {
    pageRoutes: [
      pageRoute
    ],
    apiRoutes: [
      apiRoute
    ],
    allRoutes: [
      pageRoute,
      apiRoute
    ]
  },
  preloads: {},
  cssPreloads: {},
  loaders: {}
};
var routeKey = `/app/${pageRoute.file.slice(2)}`;
var makeServerEntry = function() {
  var importPage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : async function() {
    return {};
  };
  return async function() {
    return {
      default: {
        render: function() {
          return "<html></html>";
        },
        options: {
          routes: {
            [routeKey]: importPage
          }
        }
      }
    };
  };
};
var lazyRoutes = {
  serverEntry: makeServerEntry(),
  api: {
    [apiRoute.page]: async function() {
      return {
        HEAD: function() {
          return new Response(null, {
            status: 204
          });
        }
      };
    }
  },
  middlewares: {}
};
function createHandler() {
  import_vitest.vi.stubEnv("ONE_BUFFERED_SSR", "1");
  return (0, import_workerHandler.createWorkerHandler)({
    oneOptions: {
      router: {
        root: "app"
      },
      web: {
        defaultRenderMode: "ssr"
      }
    },
    buildInfo,
    lazyRoutes
  }).handleRequest;
}
(0, import_vitest.afterEach)(function() {
  import_vitest.vi.unstubAllEnvs();
});
(0, import_vitest.describe)("createWorkerHandler", function() {
  (0, import_vitest.it)("answers HEAD page requests exactly like GET", async function() {
    var handleRequest = createHandler();
    var get = await handleRequest(new Request("https://example.com/some-page"));
    var head = await handleRequest(new Request("https://example.com/some-page", {
      method: "HEAD"
    }));
    if (!_instanceof(get, Response) || !_instanceof(head, Response)) {
      throw new Error("expected both GET and HEAD to return a Response");
    }
    (0, import_vitest.expect)(get.status).toBe(200);
    (0, import_vitest.expect)(head.status).toBe(get.status);
    (0, import_vitest.expect)(head.headers.get("content-type")).toBe(get.headers.get("content-type"));
  });
  (0, import_vitest.it)("does not route POST requests to page handlers", async function() {
    var response = await createHandler()(new Request("https://example.com/some-page", {
      method: "POST"
    }));
    (0, import_vitest.expect)(response).toBeNull();
  });
  (0, import_vitest.it)("continues routing HEAD requests to API handlers", async function() {
    var response = await createHandler()(new Request("https://example.com/api/status", {
      method: "HEAD"
    }));
    (0, import_vitest.expect)(response).toBeInstanceOf(Response);
    (0, import_vitest.expect)(response === null || response === void 0 ? void 0 : response.status).toBe(204);
  });
  (0, import_vitest.it)("disableModuleCache re-imports the page module on each request", async function() {
    import_vitest.vi.stubEnv("ONE_BUFFERED_SSR", "1");
    var imports = 0;
    var handleRequest = (0, import_workerHandler.createWorkerHandler)({
      oneOptions: {
        router: {
          root: "app"
        },
        web: {
          defaultRenderMode: "ssr"
        }
      },
      buildInfo,
      disableModuleCache: true,
      lazyRoutes: {
        ...lazyRoutes,
        serverEntry: makeServerEntry(async function() {
          imports += 1;
          return {};
        })
      }
    }).handleRequest;
    await handleRequest(new Request("https://example.com/some-page"));
    await handleRequest(new Request("https://example.com/some-page"));
    (0, import_vitest.expect)(imports).toBeGreaterThan(1);
  });
});
//# sourceMappingURL=workerHandler.test.js.map
